import { useDroppable } from '@dnd-kit/core';
import type { ReactNode } from 'react';

interface TimelineDroppableRowProps {
  rowId: string;
  isParent: boolean;
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  measureElement?: (node: HTMLDivElement | null) => void;
  dataIndex: number;
}

export const TimelineDroppableRow = ({
  rowId,
  isParent,
  children,
  className,
  style,
  measureElement,
  dataIndex,
}: TimelineDroppableRowProps) => {
  const { setNodeRef } = useDroppable({
    id: rowId,
    data: {
      type: 'timeline-row',
      rowId,
      dataIndex,
    },
    disabled: isParent,
  });

  return (
    <div
      ref={(node) => {
        setNodeRef(node);
        measureElement?.(node);
      }}
      style={style}
      className={className}
      data-testid={`timeline-drop-row-${rowId}`}
      data-index={dataIndex}
    >
      {children}
    </div>
  );
};
